//кнопка вверх
$(document).ready(function () {
  $(window).scroll(function () {
    if ($(document).scrollTop() > 10) {
      $('#scroll').css('display', 'block');
    }
    else {
      $('#scroll').css('display', 'none');
    }
  });
  $('#toTop').click(function () {
    $('html, body').animate({scrollTop: $('html').offset().top}, 'slow');
    return false;
  });
});

if (document.getElementsByClassName('image-text-link').length > 0) {
  $('.image-text-link').magnificPopup({type: 'image'});
}

//плавающая шапка
$(document).ready(function () {
  $(window).scroll(function () {
    if($(window).width() > 768) {
      if ($(document).scrollTop() > 160) {
        $('header .bottom').addClass('fixed');
      }
      else {
        $('header .bottom').removeClass('fixed');
      }
    }
    else {
      if ($(document).scrollTop() > 120) {
        $('header .mobile-block').addClass('fixed');
      }
      else {
        $('header .mobile-block').removeClass('fixed');
      }
    }

    $(window).resize(function () {
      if($(window).width() > 768) {
        $('header .mobile-block').removeClass('fixed');
        if ($(document).scrollTop() > 160) {
          $('header .bottom').addClass('fixed');
        }
        else {
          $('header .bottom').removeClass('fixed');
        }
      }
      else {
        $('header .bottom').removeClass('fixed');
        if ($(document).scrollTop() > 120) {
          $('header .mobile-block').addClass('fixed');
        }
        else {
          $('header .mobile-block').removeClass('fixed');
        }
      }
    });
  });
});

//mob menu
$('.mobile-menu-icon').click(function () {
  $('header .bottom').animate({left: '0%'}, 'slow');
});

$('.close-mobile-menu').click(function () {
  $('header .bottom').animate({left: '-100%'}, 'slow');
});

if($(window).width() < 768) {
  $('nav>.main-menu>li:nth-child(n+2)').click(function () {
    $('header .bottom').animate({left: '-100%'}, 'slow');
  });

  $('header .main-menu li.expanded').click(function () {
    $(this).toggleClass('active');
  });
}



//показать еще на главной для услуг
const showMore = document.querySelector('.show-more');
const productsLength = document.querySelectorAll('.services-front .srvices-item').length;

let items = 6;

if($('body').hasClass('home')) {
  showMore.addEventListener('click', () => {
    items += 6;
    const array = Array.from(document.querySelector('.services-array').children);
    const visItems = array.slice(0, items);

    visItems.forEach(el => el.classList.add('is-visible'));

    if (visItems.length === productsLength) {
      showMore.style.display = 'none';
    }
  });
}


//приплывание меню на заданные позиции
// if($('body').hasClass('home')) {
//   $('nav>.main-menu>li:nth-child(1), .footer-menu.about .link-block:nth-child(1)').click(function () {
//     var screen = $('.services-front').offset().top - ($(window).height() / 30) - 30;
//     $('html,body').animate({scrollTop: screen}, 800);
//     return false;
//   });
//
//   $('nav>.main-menu>li:nth-child(2), .footer-menu.about .link-block:nth-child(2)').click(function () {
//     var screen = $('.seo-text').offset().top - ($(window).height() / 30) - 30;
//     $('html,body').animate({scrollTop: screen}, 800);
//     return false;
//   });
//
//   $('nav>.main-menu>li:nth-child(3), .footer-menu.about .link-block:nth-child(3)').click(function () {
//     var screen = $('.our-team').offset().top - ($(window).height() / 30) - 30;
//     $('html,body').animate({scrollTop: screen}, 800);
//     return false;
//   });
//
//   $('nav>.main-menu>li:nth-child(4), .footer-menu.about .link-block:nth-child(4)').click(function () {
//     var screen = $('.main-page-review').offset().top - ($(window).height() / 30) - 30;
//     $('html,body').animate({scrollTop: screen}, 800);
//     return false;
//   });
//
//   $('nav>.main-menu>li:nth-child(5), .footer-menu.about .link-block:nth-child(5)').click(function () {
//     var screen = $('.main-blog').offset().top - ($(window).height() / 30) - 30;
//     $('html,body').animate({scrollTop: screen}, 800);
//     return false;
//   });
//
//   $('nav>.main-menu>li:nth-child(6), .footer-menu.about .link-block:nth-child(6)').click(function () {
//     var screen = $('.faq-block-parent').offset().top - ($(window).height() / 30) - 30;
//     $('html,body').animate({scrollTop: screen}, 800);
//     return false;
//   });
// }





// WEBPACK FOOTER //
// ./resources/js/snippets/common.js